import React from 'react';
import PurchasesTableActions from '../../components/dashboard/PurchasesTableActions';

export default [
  {
    id: 1,
    customer: 'Sylvia Plath',
    email: 'john@gmail.com',
    product: 'Slick - Drag & Drop Bootstrap Generator',
    status: 'success',
    amount: 99,
    action: <PurchasesTableActions />
  },
  {
    id: 2,
    customer: 'Homer',
    email: 'sylvia@mail.ru',
    product: 'Bose SoundSport Wireless Headphones',
    status: 'success',
    amount: 634,
    action: <PurchasesTableActions />
  },
  {
    id: 3,
    customer: 'Edgar Allan Poe',
    email: 'edgar@yahoo.com',
    product: 'All-New Fire HD 8 Kids Edition Tablet',
    status: 'blocked',
    amount: 199,
    action: <PurchasesTableActions />
  },
  {
    id: 4,
    customer: 'William Butler Yeats',
    email: 'william@gmail.com',
    product: 'Apple iPhone XR (64GB)',
    status: 'success',
    amount: 798,
    action: <PurchasesTableActions />
  },
  {
    id: 5,
    customer: 'Rabindranath Tagore',
    email: 'tagore@twitter.com',
    product: 'ASUS Chromebook C202SA-YS02 11.6"',
    status: 'blocked',
    amount: 318,
    action: <PurchasesTableActions />
  },
  {
    id: 6,
    customer: 'Emily Dickinson',
    email: 'emily@gmail.com',
    product: 'Mirari OK to Wake! Alarm Clock & Night-Light',
    status: 'pending',
    amount: 11,
    action: <PurchasesTableActions />
  },
  {
    id: 7,
    customer: 'Giovanni Boccaccio',
    email: 'giovanni@outlook.com',
    product: 'Summer Infant Contoured Changing Pad',
    status: 'success',
    amount: 31,
    action: <PurchasesTableActions />
  },
  {
    id: 8,
    customer: 'Oscar Wilde',
    email: 'oscar@hotmail.com',
    product: 'Munchkin 6 Piece Fork and Spoon Set',
    status: 'success',
    amount: 43,
    action: <PurchasesTableActions />
  },
  {
    id: 9,
    customer: 'John Doe',
    email: 'doe@gmail.com',
    product: 'Falcon - Responsive Dashboard Template',
    status: 'success',
    amount: 57,
    action: <PurchasesTableActions />
  },
  {
    id: 10,
    customer: 'Emma Watson',
    email: 'emma@gmail.com',
    product: 'Apple iPhone XR (64GB)',
    status: 'blocked',
    amount: 999,
    action: <PurchasesTableActions />
  },
  {
    id: 11,
    customer: 'Sylvia Plath',
    email: 'plath@yahoo.com',
    product: 'All-New Fire HD 8 Kids Edition Tablet',
    status: 'pending',
    amount: 199,
    action: <PurchasesTableActions />
  },
  {
    id: 12,
    customer: 'Iori Kim',
    email: 'ikim@yahoo.com',
    product: 'ASUS Chromebook C202SA-YS02 11.6"',
    status: 'pending',
    amount: 200,
    action: <PurchasesTableActions />
  }
];
